import type { CardSummary, EligibleCard } from "./cards.types";

// Only debit cards that are currently active can be passed back — this mirrors
// the backend precondition validator (owned, debit, non-blocked). Anything else
// is hidden rather than shown disabled, since the grant is all-or-nothing.
export function eligibleCards(cards: CardSummary[]): EligibleCard[] {
  return cards.filter((c) => c.cardType === "debit" && c.availability.active);
}
